// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable {\r\n  border-collapse: collapse;\n}\ntable td {\r\n  padding: 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;
